'use client';
import styled from 'styled-components';

export const FormFieldsContainer = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: ${props => (props.$maxWidth ? `${props.$maxWidth}px` : 'none')};
  margin: auto;
`;

export const FormWrapper = styled.div`
  position: fixed;
  min-height: ${props =>
    props.$minHeight ? `${props.$minHeight}px` : '321px'};
  bottom: 0;
  width: 100%;
  padding-top: ${props => props.theme.spacing(8)};
  border-radius: 32px 32px 0 0;
  overflow: hidden;
  background-color: ${props => props.theme.colors.background.base};

  @media ${props => props.theme.laptop} {
    position: static;
    width: 50%;
    display: flex;
    justify-content: space-around;
    text-align: center;
    border-radius: 0;
  }
`;

export const FormWrapperCRO = styled(FormWrapper)`
  margin: auto;
  padding-bottom: 24px;
  @media ${props => props.theme.laptop} {
    display: block;
  }
`;

export const FormFieldsContainerCRO = styled(FormFieldsContainer)`
  margin: auto;
`;
